import {Component, Inject, OnInit, QueryList, ViewChildren} from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {first} from "rxjs/operators";
import {StudentOverrideConstants} from "./student-override.constants";
import {UnsavedChangesService} from "@tva/ng-migration/shared/services/unsavedChanges.service";
import {NotificationService, TvActionChipsComponent} from "@tva/ng-migration/uicomponents";
import {EmptyOverrideValidator} from "@tva/ng-migration/student/components/student-cre-tracking/student-override-modal/student-override-modal.validators";

@Component({
  selector: 'app-student-override-modal',
  templateUrl: './student-override-modal.component.html',
  styleUrls: ['./student-override-modal.component.scss'],
})
export class OverrideModalComponent implements OnInit {
  wasModified: boolean;
  wasValidated: boolean;
  overrideCourses: any[];
  transcriptCourses: any[];
  form: FormGroup;


  @ViewChildren(TvActionChipsComponent) courseLists: QueryList<TvActionChipsComponent>;


  constructor(@Inject(MAT_DIALOG_DATA) public data: { requirement, overrideCourses, transcriptCourses },
              public dialogRef: MatDialogRef<OverrideModalComponent>,
              private unsavedChanges: UnsavedChangesService,
              private notificationService: NotificationService) {
  }

  get errorMessages() {
    return StudentOverrideConstants.errors;
  }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.loadData();
    this.createForm();
  }

  errorIsShown(control: AbstractControl): boolean {
    return this.wasValidated && control.touched;
  }

  done() {
    if (this.validate()) {
      const updatedRequirement = this.createOverrideRequirement();
      this.dialogRef.close(updatedRequirement);
      this.unsavedChanges.startChanges();
      this.notificationService.hideErrorMessage();
    } else {
      this.notificationService.showErrorMessage();
    }
  }

  close() {
    if (this.wasModified) {
      this.unsavedChanges.ask(() => {
        this.dialogRef.close();
      }, StudentOverrideConstants.unsaved_messages);
    } else {
      this.dialogRef.close();
    }
  }

  private loadControlTriggerChange(control: AbstractControl) {
    control.valueChanges.pipe(first()).subscribe(() => {
      this.notifyModification();
    })
  }

  private loadData() {
    this.overrideCourses = this.data.overrideCourses;
    this.transcriptCourses = this.data.transcriptCourses;
    this.overrideCourses.sort((c1, c2) => c1.courseName.localeCompare(c2.courseName));
    this.transcriptCourses.sort((c1, c2) => c1.name.localeCompare(c2.name));
  }

  private notifyModification() {
    this.wasModified = true;
  }

  private createForm() {
    const course = this.data.requirement.requiredCourses.find(course=>course.courseOverride);
    let selectedOverride, selectedTranscript;
    if (course){
      selectedOverride = this.overrideCourses.find(override=>override.courseId === course.courseId);
      selectedTranscript = this.transcriptCourses.find(transcript=>transcript.id === +course.courseOverride.tranCourseId);
    } else {
      selectedOverride = this.overrideCourses[0];
    }
    selectedOverride = selectedOverride? [selectedOverride] : [];
    selectedTranscript = selectedTranscript? [selectedTranscript] : [];

    this.form = new FormGroup({
      override: new FormControl(selectedOverride),
      transcript: new FormControl(selectedTranscript),
    }, [EmptyOverrideValidator]);

    this.loadControlTriggerChange(this.form);
  }

  private validate(): boolean {
    this.form.markAsTouched();
    this.wasValidated = true;
    return this.form.valid;
  }

  private createOverrideRequirement() {
    const overriddenCourse = this.data.requirement.requiredCourses.find(course => course.courseOverride);
    const {override, transcript} = this.form.value;
    delete overriddenCourse?.courseOverride;

    if (override.length && transcript.length){
      const selectedCourse = this.data.requirement.requiredCourses.find(course => course.id === override[0].id );
      selectedCourse.courseOverride = {"tranCourseId": transcript[0].id, "courseName": transcript[0].name, "grade": transcript[0].gradeMark};
    }

    return this.data.requirement;
  }
}
